import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { CobuStack, CobuButton, CobuText } from '@cobu/ui'
import { Strings } from '../../constants/Strings';


type Props = {
  userName: string
  onReportUser: () => void | Promise<void>
  onBlockUser: () => void | Promise<void>
  canReport?: boolean
}

export type PublicProfileActionSheetRef = { show: () => void }

const PublicProfileActionSheet = forwardRef<PublicProfileActionSheetRef, Props>(({ userName, onReportUser, onBlockUser, canReport = true }, ref) => {
  const [visible, setVisible] = useState(false)
  const strings = Strings.get();
  const show = () => setVisible(true)
  const hide = () => setVisible(false)

  useImperativeHandle(ref, () => ({ show }))

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{ position: 'fixed', inset: 0, zIndex: 1000, backgroundColor: 'var(--blackTransparent50)' }}
      onClick={hide}
    >
      <div
        style={{
          position: 'absolute', left: 0, right: 0, bottom: 0,
          background: 'var(--backgroundSecondary)',
          borderTopLeftRadius: 12, borderTopRightRadius: 12,
          padding: 16,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <CobuStack gap="$2">
          <CobuText variant="body" color="$cobuDarkBlue">{userName}</CobuText>
          {canReport && (
            <CobuButton dsVariant="secondary" onPress={() => { hide(); onReportUser() }}>
              {strings.publicProfile.actions.reportUser}
            </CobuButton>
          )}
          <CobuButton dsVariant="secondary" onPress={() => { hide(); onBlockUser() }}>
            <CobuText variant="body" color="$error">{strings.publicProfile.actions.blockUser}</CobuText>
          </CobuButton>
        </CobuStack>
        <CobuStack mt="$2">
          <CobuButton dsVariant="secondary" onPress={hide}>
            {strings.publicProfile.buttons.cancel}
          </CobuButton>
        </CobuStack>
      </div>
    </div>
  )
})

export default PublicProfileActionSheet


